import { Image } from '@accedo/ctv-image';
import { FunctionalComponent } from 'preact';
import { stylesheet } from 'astroturf';
import { ShowTile } from '##/services/tenApi/common/types';

const styles = stylesheet`
  @import '##/styles/import.scss';

  .card-container {
    display: flex;
    width: pxToVw(166);
    margin-right: pxToVw(20);
    flex-shrink: 0;
  }
  .image {
    background-color: $primary-grey-30;
    object-fit: cover;
  }

  :global(.current-focus) .image {
    box-shadow: 0 0 0 2px $pure-white;
    border-radius: 2px;
    transform: scale(1.1, 1.1);
  }
`;

const PosterCarouselTile: FunctionalComponent<ShowTile & {
  isInbound: boolean;
  domId: string;
}> = ({ imageUrl, domId, isInbound }) => {
  const fallbackUrl = '/assets/placeholders/Fallback-Poster.jpg';

  return (
    <div className={styles.cardContainer} id={domId}>
      {isInbound ? (
        <Image
          className={styles.image}
          url={
            imageUrl ? `${imageUrl}?image-profile=foxtel_poster` : fallbackUrl
          }
          fallbackUrl={fallbackUrl}
          width={166}
          height={251}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default PosterCarouselTile;
